// Inject Google Analytics script (tracking handled by useGoogleAnalytics hook)
// Hanya jalankan di production untuk menghindari ERR_ABORTED di localhost
export function maybeInjectGoogleAnalytics(googleAnalyticsId?: string) {
    if (import.meta.env.PROD && googleAnalyticsId) {
        // 🔒 SECURITY: Sanitize GA ID to prevent XSS injection
        const rawGaId = googleAnalyticsId;
        const gaId = rawGaId.replace(/[^a-zA-Z0-9-]/g, '');

        // Validate GA ID format (Google Analytics IDs: G-XXXXXXXXXX or UA-XXXXXXXX-X)
        const isValidGaId = /^(G-[A-Z0-9]{10}|UA-[0-9]{4,10}-[0-9]{1,4})$/.test(gaId);

        if (!isValidGaId) {
            console.error('🚨 SECURITY: Invalid Google Analytics ID format:', rawGaId);
            return;
        }

        // Check if script already exists
        if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`)) {
            // Add gtag.js script
            const gtagScript = document.createElement('script');
            gtagScript.async = true;
            gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
            document.head.appendChild(gtagScript);

            // Add gtag config script - disable automatic page view (handled by React Router hook)
            const configScript = document.createElement('script');
            // Use textContent instead of innerHTML for security
            configScript.textContent = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${gaId}', { 'send_page_view': false });
            `;
            document.head.appendChild(configScript);

            console.log('📊 Google Analytics initialized:', gaId);
        }
    }
}
